import axios from 'axios';
import UiElement from '../../../shared/ui-element/ui-element';

class EmailSubscription extends UiElement {
  ui = {
    formGroup: '.js-email-subscription-form-group',
    emailInput: '.js-email-subscription-email-input',
    emailBtn: '.js-email-subscription-submit-btn',
  };

  events = {
    'submit @rootElement': 'handleFormSubmit',
  };

  static formGroupControlValidClass = 'form-group__form-control_valid';

  static formGroupControlInvalidClass = 'form-group__form-control_invalid';

  static formGroupValidatedClass = 'form-group_validated';

  constructor(options) {
    super(options);

    this.onSubscribeSuccess = options.onSubscribeSuccess || (() => {});
  }

  onInit() {
    this.apiUrl = this.rootElement.action;
  }

  handleFormSubmit(e) {
    e.preventDefault();
    const btn = this.ui.emailBtn;

    btn.disabled = true;

    const email = this.ui.emailInput.value;

    return axios.post(this.apiUrl, { email })
      .then(() => {
        this.emailSubscriptionSuccess();
        this.onSubscribeSuccess();
      })
      .catch(this.emailSubscriptionError)
      .then(() => {
        btn.disabled = false;
      });
  }

  setValidFormControl(formControl) {
    formControl.classList.remove(EmailSubscription.formGroupControlInvalidClass);
    formControl.classList.add(EmailSubscription.formGroupControlValidClass);
  }

  setInvalidFormControl(formControl) {
    formControl.classList.remove(EmailSubscription.formGroupControlValidClass);
    formControl.classList.add(EmailSubscription.formGroupControlInvalidClass);
  }

  emailSubscriptionSuccess = () => {
    this.setValidFormControl(this.ui.emailInput);
    this.ui.formGroup.classList.add(EmailSubscription.formGroupValidatedClass);
  };

  emailSubscriptionError = () => {
    this.setInvalidFormControl(this.ui.emailInput);
    this.ui.formGroup.classList.add(EmailSubscription.formGroupValidatedClass);
  };
}

export default EmailSubscription;
